"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAsterisk(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.979 0c.388 0 .708.288.759.662l.007.104-.001 9.605 9.037-5.164a.766.766 0 01.846 1.273l-.086.057-9.034 5.162 9.034 5.162a.766.766 0 01-.667 1.376l-.093-.046-9.037-5.164v10.207a.766.766 0 01-1.524.104l-.007-.104-.001-10.224-9.066 5.181A.766.766 0 011.3 16.92l.087-.058L10.42 11.7 1.386 6.537a.766.766 0 01.666-1.375l.094.045 9.066 5.181V.766c0-.423.344-.766.767-.766z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgAsterisk;
exports.default = _default;